'use client'
import React from 'react'
import cls from 'classnames'
import styles from './styles.module.scss'

export interface BadgeProps {
  count?: number | string
  maxCount?: number
  dot?: boolean
  showZero?: boolean
  offset?: [number, number]
  color?: string
  className?: string
  style?: React.CSSProperties
  children?: React.ReactNode
}

const Badge: React.FC<BadgeProps> = ({
  count,
  maxCount = 99,
  dot = false,
  showZero = false,
  offset,
  color,
  className,
  style,
  children,
}) => {
  const showBadge = dot || (typeof count === 'number' && count > 0) || showZero

  const badgeContent = dot ? null : typeof count === 'number' && count > maxCount ? `${maxCount}+` : count

  const badgeStyle = {
    ...style,
    backgroundColor: color,
    right: offset?.[0] ? -offset[0] : undefined,
    top: offset?.[1] ? -offset[1] : undefined,
  }

  return (
    <div className={cls(styles.badgeWrapper, className)}>
      {children}
      {showBadge && (
        <span
          className={cls(styles.badge, {
            [styles.dot]: dot,
            [styles.alone]: !children,
          })}
          style={badgeStyle}
        >
          {badgeContent}
        </span>
      )}
    </div>
  )
}

export default Badge
